import React from "react";

import { parseDocType } from "EmployerApplication/Components/documentPicker/utils";
import { squareTaxFormLink, squareHistoryLink } from "Square/urls";

import type { UploadDocsProp } from "Utils/types";

export const squareDocsDescription = (props: UploadDocsProp) => {
  const docType = parseDocType(props.fileInputName);
  switch (docType) {
    case "state_wage_report":
      return <StateWageReport {...props} />;
    case "payroll_journal":
      return <PayrollJournal {...props} />;
    default:
      return props.description;
  }
};

const dateRange = (daysBack) => {
  const today = new Date();
  const endDate = today.toLocaleDateString();
  today.setDate(today.getDate() - daysBack);
  const startDate = today.toLocaleDateString();
  return `${startDate} - ${endDate}`;
};

const PayrollJournal = (props) => (
  <ol className="PayrollJournal">
    <li>
      Go to the{" "}
      {
        <a target="_blank" href={squareHistoryLink} rel="noreferrer">
          History tab
        </a>
      }{" "}
      within your Square Payroll dashboard
    </li>
    <li>Click "Export custom report"</li>
    <img className="PayrollJournal__Instructions" src="/assets/square/payroll_journal.png" />

    <li>
      Once here, select date range <b>{props.title == "Most recent 90-day company payroll journal" ? dateRange(90) : dateRange(30)}</b>
    </li>
    <li>
      Select <b>All Employees</b>
    </li>
    <li>
      Select <b>Employee Totals</b>
    </li>
    <li>
      Click <b>Export to CSV</b>
    </li>
    <li>Upload the CSV to SImplyInsured</li>
  </ol>
);

const StateWageReport = (props) => (
  <ol>
    <li>
      Go to the{" "}
      {
        <a target="_blank" href={squareTaxFormLink} rel="noreferrer">
          Tax Forms tab
        </a>
      }{" "}
      within your Square Payroll dashboard
    </li>
    <li>
      Search for most recent {props.title} form. Make sure this document is from the right quarter, and is also not the 941, which is not the document required.
    </li>
    <li>Click "Download" on the right side of the screen</li>
    <li>Upload the PDF to SimplyInsured</li>
  </ol>
);
